

const STATIC_MOVIE_CATEGORIES = [
  {id: 'popular', name: 'Popular'},
  {id: 'top_rated', name: 'Top Rated'},
  {id: 'upcoming', name: 'Upcoming'}
];

export default STATIC_MOVIE_CATEGORIES;
